import { X } from "lucide-react";
import type { DashboardData } from "../../types";
import { shortName } from "../../lib/finance";
import type { TransactionsViewProps } from "./TransactionsView";

export default function TransactionActiveFilters({ data, filters, today, dateLabel }: {
  data: DashboardData;
  filters: TransactionsViewProps["filters"];
  today: string;
  dateLabel: (date: string) => string;
}) {
  const { reporting, setReporting, category, setCategory, subcategory, setSubcategory,
    type, setType, accountFilter, setAccountFilter, dateFilter, setDateFilter, tripFilter, setTripFilter } = filters;
  if (!reporting && subcategory === null && ![category, type, accountFilter, dateFilter, tripFilter].some(v => v && v !== "All")) return null;
  return (
    <div className="active-filters" aria-label="Selected transaction filters">
      {category !== "All" && <button onClick={() => setCategory("All")}>{category}<X size={12} /></button>}
      {subcategory !== null && <button onClick={() => setSubcategory(null)}>{subcategory || "Unspecified"}<X size={12} /></button>}
      {accountFilter !== "All" && <button onClick={() => setAccountFilter("All")}>{shortName(data.accounts.find(a => a.id === accountFilter)?.name || accountFilter)}<X size={12} /></button>}
      {type !== "All" && <button onClick={() => setType("All")}>{type}<X size={12} /></button>}
      {tripFilter && tripFilter !== "All" && <button onClick={() => setTripFilter?.("All")}>Trip: {data.trips?.find(t => t.id === tripFilter)?.name || tripFilter}<X size={12} /></button>}
      {dateFilter && <button onClick={() => setDateFilter("")}>{dateLabel(dateFilter)}<X size={12} /></button>}
      {reporting && <>
        <button aria-label="Clear insight filters" title="Saved income and spending only" onClick={() => setReporting?.(null)}>Insights · saved through {dateLabel(today)}<X size={12} /></button>
        {reporting.activity !== "all" && <button aria-label="Clear insight activity filter" onClick={() => setReporting?.({ ...reporting, activity: "all" })}>{reporting.activity === "trips" ? "Trips only" : "Everyday only"}<X size={12} /></button>}
        {reporting.merchant !== undefined && <button aria-label="Clear insight merchant filter" onClick={() => setReporting?.({ activity: reporting.activity })}>Merchant: {reporting.merchant || "No merchant recorded"}<X size={12} /></button>}
      </>}
      <button onClick={() => {
        setReporting?.(null); setCategory("All"); setSubcategory(null); setAccountFilter("All");
        setType("All"); setDateFilter(""); setTripFilter?.("All");
      }}>Clear all</button>
    </div>
  );
}
